import { render, staticRenderFns } from "./addHelp.vue?vue&type=template&id=aa74818a&scoped=true&"
import script from "./addHelp.vue?vue&type=script&lang=js&"
export * from "./addHelp.vue?vue&type=script&lang=js&"
import style0 from "./addHelp.vue?vue&type=style&index=0&id=aa74818a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa74818a",
  null
  
)

export default component.exports